define('helpers/PasswordValidatorHelper',['env'], function (Config) {
    return {
        passwordValidator: function (value) {
            var passwordMinLength = Config.SECURE_PASSWORD_LENGTH;
            var valid = true;

            var styleBefore = '<span>';
            var styleAfter = '</span>';
            var message = [styleBefore + $.i18n.translate('FORM.VALIDATION.TXT_PASSWORD_SOULD_HAVE') + styleAfter];

            if (value.length < passwordMinLength) {
                valid = false;
                message.push(styleBefore + $.i18n.translate('FORM.VALIDATION.TXT_PASSWORD_LENGTH' + passwordMinLength) + styleAfter);
            }

            if (value === value.toLowerCase() || value === value.toUpperCase()) {
                valid = false;
                message.push(styleBefore + $.i18n.translate('FORM.VALIDATION.TXT_PASSWORD_CASE') + styleAfter);
            }

            if (value.search(/[0-9]/) < 0) {
                valid = false;
                message.push(styleBefore + $.i18n.translate('FORM.VALIDATION.TXT_PASSWORD_DIGITS') + styleAfter);
            }

            if (value.search(/[!"#$%&'()*+,-./:;<=>?@[\\\]]/) < 0) {
                valid = false;
                message.push(styleBefore + $.i18n.translate('FORM.VALIDATION.TXT_PASSWORD_SPECIAL_CHARACTERS') + styleAfter);
            }

            if (!valid) {
                return {
                    valid: false,
                    message: message
                };
            }

            return true;
        }
    };
});

